import React from 'react';
import classNames from 'classnames';

import css from './PopupOpenerButton.module.css';
import { IconArrowHead } from '../../../components';

/**
 * PopupOpenerButton component
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.isSelected] - Whether the filter is selected
 * @param {number} [props.labelMaxWidth] - The maximum width of the label
 * @param {Function} props.toggleOpen - The function to toggle the filter
 * @param {React.Node} props.children - The children
 * @returns {JSX.Element}
 */
const PopupOpenerButton = props => {
  const {
    isSelected = false,
    labelMaxWidth = null,
    toggleOpen,
    children,
    className,
    hideArrowIcon = false,
  } = props;

  const labelStyles = isSelected ? css.labelSelected : css.label;
  const labelMaxWidthMaybe = labelMaxWidth ? { maxWidth: `${labelMaxWidth}px` } : {};
  const labelMaxWidthStyles = labelMaxWidth ? css.labelEllipsis : null;

  return (
    <button
      className={className || classNames(labelStyles, labelMaxWidthStyles)}
      style={labelMaxWidthMaybe}
      onClick={() => toggleOpen()}
      type="button"
    >
      {children}
      {!hideArrowIcon && <IconArrowHead direction="down" className={css.arrowIcon} size="small" />}
    </button>
  );
};

export default PopupOpenerButton;
